<div *ngIf="position==='doc-tab'" class="tab-wrap" [ngClass]="{'fundraiser-page': !vars.pageName.match('stories|mini_story')}">
  <mat-card>
    <div class="title">{{'Stories.documentText' | translatePipe | async}}</div>
    <div class="place-holder">
      <img loading="lazy" [attr.data-src]="'../assets/images/med-doc-place-holder.png'" alt="med-doc-place-holder">
      <div class="layout">
        <div class="title-count">{{fundraiser?.count_medical_bill}} {{('Stories.loginDocumentLayout.title' | translatePipe | async)?.replace(fundraiser?.count_medical_bill > 1 ? 'document' : '....', 'documents')}}</div>
        <div class="sub-title">{{'Stories.loginDocumentLayout.subTitle' | translatePipe | async}}</div>
        <ng-template [ngTemplateOutlet]="loginBtn" />
      </div>
    </div>
    <div *ngIf="vars.pageName.match('stories|mini_story') && !isMobile">
      <ng-template [ngTemplateOutlet]="shareTemp" />
    </div>
  </mat-card>

  <div *ngIf="!vars.pageName.match('stories|mini_story') && !isMobile">
    <ng-template [ngTemplateOutlet]="shareTemp" />
  </div>
</div>

<div *ngIf="position==='about'" class="row-wrap">
  <div class="content">
    <div class="place-holder">
      <img *ngIf="!isMobile" loading="lazy" [attr.data-src]="'../assets/images/med-doc-place-holder-1.png'" alt="med-doc-place-holder">
      <img *ngIf="isMobile" loading="lazy" [attr.data-src]="'../assets/images/med-doc-place-holder-2.png'" alt="med-doc-place-holder">
      <div class="layout">
        <div class="text">
          <div class="title-count">{{fundraiser?.count_medical_bill}} {{('Stories.loginDocumentLayout.title' | translatePipe | async)?.replace(fundraiser?.count_medical_bill > 1 ? 'document' : '....', 'documents')}}</div>
          <div class="sub-title">{{'Stories.loginDocumentLayout.subTitle' | translatePipe | async}}</div>
        </div>
        <div class="act-btn">
          <ng-template [ngTemplateOutlet]="loginBtn" />
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #loginBtn>
  <app-basic-button
    postIcon="arrow_forward"
    label="{{'Stories.loginDocumentLayout.medicalBtnLable' | translatePipe | async}}"
    [themeConfig]="position==='about' && !isMobile ? {bgColor: '#FCFCFC', textColor: '#01BFBD'} : {bgColor: '#01BFBD', textColor: '#FCFCFC'}"
    (btnClicked)="openLogin()"
  />
</ng-template>


<app-signin-signup [popupView]="true" [numberOnly]="true" [showPopup]="openLoginPopup" [noRedirectAfterLogin]="true" (onClose)="signinClosed()" />

<ng-template #shareTemp>
  <div class="social-share">
    <app-whatsapp-share
      label="Share" [count]="sharedCounts?.whatsapp" [fundraiser]="fundraiser"
      [isFundraiserEnded]="isFundraiserEnded" [basicInfo]="basicInfo" [position]="3"
    />
    <app-fb-share label="Share" [count]="sharedCounts?.fb" [position]="3" />
    <app-donate-now *ngIf="!isFundraiserEnded" label="Contribute Now" [fundraiser]="fundraiser" [position]="3" />
  </div>
</ng-template>
